module.exports = __webpack_public_path__ + "static/media/dripping-ceiling.10b1908b.png";